<script lang="ts" setup>
  defineEmits<{ click: [] }>();
</script>

<template>
  <button type="button" @click="$emit('click')"><slot /></button>
</template>

<style scoped>
  button {
    background: none;
    border: none;
    color: var(--color-primary);
    cursor: pointer;
    font: inherit;
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-strong);
    margin-top: 40px;
    min-height: var(--size-touch-target);
    min-width: var(--size-touch-target);
    padding: 0 1rem;
    text-align: center;

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }
  }
</style>
